import React, { useState } from 'react';

import ManagePromoCodeSection from '../../../components/siteadmin/ManagePromoCode/ManagePromoCodeSection';
import Loader from '../../../components/Loader/Loader';

import { getAllPromoCode } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';

function PromoCodeManagement(props) {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchKey, setSearchKey] = useState("");

    const setStateVariable = (variables) => {
        if (variables.currentPage !== undefined) {
            setCurrentPage(variables.currentPage);
        }
    };
    const { data: { getAllPromoCode, refetch, loading }, title } = props

    return (
        <div>
            {loading && <Loader type='text' />}
            {!loading && <ManagePromoCodeSection
                setStateVariable={setStateVariable}
                currentPage={currentPage}
                title={title}
                searchKey={searchKey}
                getAllPromoCode={getAllPromoCode}
                refetch={refetch}
                loading={loading}
            />}
        </div>

    );
}

export default withQuery(getAllPromoCode, {
    options: (props) => ({
        variables: {
            currentPage: props.currentPage,
            searchKey: props.searchKey
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
})(PromoCodeManagement);